import styled from 'styled-components';
import React from 'react';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
	return (
		<>
			<Helmet title="Not Found" />
			<NotFoundContainer>
				<NotFoundHeader>404: Page not found</NotFoundHeader>
				<NotFoundText>
					Sorry, this page does not exist! <br />
					Please click <Link href="/">this link</Link> to go back to the homepage
				</NotFoundText>
			</NotFoundContainer>
		</>
	);
};

export default NotFound;

const NotFoundContainer = styled.section`
	width: 100%;
	height: 450px;
	margin: auto;
`;

const NotFoundHeader = styled.h1`
	margin: auto;
	height: 200px;
	font-size: 34px;
	text-align: center;
	padding-top: 100px;
`;

const NotFoundText = styled.div`
	margin: auto;
	width: 300px;
`;

const Link = styled.a`
	color: #00a8ff;
`;
